import { saveAs } from 'file-saver';
import ErrorMessage from '../../../Elements/ErrorMessage';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import AuthService from '../../../Services/authService';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';

class ExportReport 
{

    static SaveAsExcel(filter, filename, callBack=null)
    {
        var useremail = AuthService.getInstance().GetLoggedInUser().email;
        var user = useremail.substr(0, useremail.indexOf('@'));
        filename += '_' + user + '_'
            + dateTimeHelper.toYYYYsMMsDD(filter.StartDate).split('-').join('')
            + '-' + dateTimeHelper.toYYYYsMMsDD(filter.EndDate).split('-').join('') + '.xlsx';

        
        PlanningDetailsItemService.GetPlanningDetailsItemsReport(filter)
            .then(textResult=>{
                const byteCharacters = atob(textResult);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                saveAs(new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), filename);
                if(callBack!==null)
                {
                    callBack();
                }
            })
            .catch(error=>ErrorMessage.SetErrorMessage("ER32"));
    }
}

export default ExportReport;